// removed by extract-text-webpack-plugin
module.exports = {"component":"src-components-AssessmentComponents-__MultiChoiceAssessment-module___component","question":"src-components-AssessmentComponents-__MultiChoiceAssessment-module___question","choices":"src-components-AssessmentComponents-__MultiChoiceAssessment-module___choices","choice":"src-components-AssessmentComponents-__MultiChoiceAssessment-module___choice","btnPar":"src-components-AssessmentComponents-__MultiChoiceAssessment-module___btnPar","answerIcon":"src-components-AssessmentComponents-__MultiChoiceAssessment-module___answerIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AssessmentComponents/MultiChoiceAssessment.module.css
// module id = 233
// module chunks = 0